<template>
    <div>
        <div class="my-white-mod" style="min-height:500px;padding-bottom:30px" >
            <h1 >成交时间排名</h1>
            
            <Table border  height="500" :loading="table.loading"   :columns="table.columns" :data="table.data">
            </Table>
            <Page :total="table.total" :current="table.page" :page-size="table.limit" @on-change="changePage" show-elevator show-total class-name="page-class"  />
        </div>
    </div>
</template> 

<script>
    import {pay_time_order} from "@/api/statistics"
    export default {
        name:"PayTimeOrder",
        props:{
        },
        data() {
            return {
                table:{
                    page:1,
                    limit:30, 
                    total:0,
                    loading:false,
                    data:[],
                    columns: [
                        {
                            title: '排名',
                            align:'center',
                            render:(h, p)=>{
                                return h('span', p.index + (this.table.page - 1) * this.table.limit  + 1)
                            }
                        },
                        {
                            title: '单号',
                            align:'center',
                            key: 'id'
                        },
                        {
                            title: '销售人员',
                            align:'center',
                            key: 'name'
                        },
                        {
                            title: '销售额',
                            align:'center',
                            key: 'pay_money'
                        },
                        {
                            title: '渠道',
                            align:'center',
                            key: 'tags'
                        },
                        {
                            title: '成交周期',
                            align:'center',
                            key: 'days'
                        },
                        {
                            title: '成交时间',
                            align:'center',
                            key: 'pay_time'
                        },
                        {
                            title: '售后',
                            align:'center',
                            key: 'after_name'
                        }
                    ]
                },
            }
        },
        created () {
                this.getList();
        },
        methods: {
            getList(){
                this.table.loading = true;
                pay_time_order({limit:this.table.limit, page:this.table.page}).then(res=>{
                    this.table.loading = false;
                    if (res.code == 200) {
                        this.table.data = res.data.data;
                        this.table.total = res.data.total;
                    } else {
                        this.table.data = [];
                        this.table.total = 0;
                        this.$Message.error(res.msg);
                    }
                }).catch(err=>{
                    this.table.loading = false;
                })
            },
            
            changePage(e){
                this.table.page = e;
                this.getList();
            },
        }
    }
</script>

<style scoped>
.ivu-table-wrapper-with-border{
    border-bottom:1px solid #dcdee2;
}
.font-left{
    font-size:20px;text-align: left;
}

.page-class{
    margin-top:10px;text-align: right
}
</style>